import React, { useEffect } from 'react';
import { Datagrid, TextField, useUnselectAll, Loading } from 'react-admin';
import EditButtonWithOnClick from '../../../core/components/EditButtonWithOnClick';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  editButton: {
    color: '#757575',
    minWidth: '24px',
    padding: '6px 0',
    '& span': {
      paddingRight: 0
    }
  },
  editButtonColumnStyle: {
    width: '24px'
  }
});

const UserAddressDatagrid = props => {
  const {
    handleAddressEditButtonClick,
    classes,
    hasEditPermission,
    ...dataGridProps
  } = props;

  //unselecting all the checkboxes from the deleting actions in the ComponenWillUnmount listener
  const unSelectAll = useUnselectAll(dataGridProps.resource);

  useEffect(() => () => unSelectAll(), [unSelectAll]);

  if (props.total > 0) {
    return (
      <Datagrid {...dataGridProps}>
        <TextField source="addressType" label="Address Type" sortable={false} />
        <TextField
          source="addressLine1"
          label="Address Line 1"
          sortBy="address"
          sortable={false}
          id="address-1"
        />
        <TextField
          source="addressLine2"
          label="Address Line 2"
          sortable={false}
          id="address-2"
        />
        <TextField
          source="addressLine3"
          label="Address Line 3"
          sortable={false}
          id="address-3"
        />
        <TextField
          source="countryFullName"
          label="Country"
          sortable={false}
          id="country"
        />
        <TextField
          source="stateFullName"
          label="State/Province"
          sortable={false}
          id="state"
        />
        <TextField source="city" label="City" sortable={false} id="city" />
        <TextField
          source="postalCode"
          label="ZIP/Postal Code"
          sortable={false}
          id="postal-code"
        />
        {hasEditPermission && (
          <EditButtonWithOnClick
            label=""
            className={classes.editButton}
            headerClassName={classes.editButtonColumnStyle}
            cellClassName={classes.editButtonColumnStyle}
            onClick={handleAddressEditButtonClick}
          />
        )}
      </Datagrid>
    );
  } else if (props.loading) {
    return <Loading />;
  } else {
    return 'There are no addresses to be displayed';
  }
};

export default withStyles(styles)(UserAddressDatagrid);
